/**
 * Map a raw auto-updater error (electron-updater / Electron net stack) into a
 * short, user-friendly message. Raw errors are never shown to the operator.
 */
export function friendlyUpdateError(raw: string | null): string {
  const text = (raw ?? '').toLowerCase();
  if (/net::|internet|econn|enotfound|etimedout|network|getaddrinfo|dns/.test(text)) {
    return 'Connection lost. Check your internet and try again.';
  }
  if (/enospc|disk|space/.test(text)) {
    return 'Not enough disk space to download the update.';
  }
  if (/sha|checksum|signature|verify|integrity/.test(text)) {
    return 'Download was corrupted. Please try again.';
  }
  return 'Update failed. Please try again.';
}
